import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './Widget.module.scss';

export enum TitleFontSize {
  DEFAULT = 'default',
  LARGE = 'large',
}

export enum TitleFontWeight {
  MEDIUM = 'medium',
  BOLD = 'bold',
}

export type WidgetProps = {
  title?: ReactNode; // if loading - title is ReactComponent
  children: ReactNode;
  titleFontSize?: TitleFontSize;
  titleFontWeight?: TitleFontWeight;
  // used previously for creating Skeleton from Widget
  // if loading is true, padding = 0
  loading?: boolean;
  className?: string;
  titleClassName?: string;
  contentClassName?: string;
};

export const Widget: FC<WidgetProps> = ({
  children,
  title,
  titleFontSize = TitleFontSize.DEFAULT,
  titleFontWeight = TitleFontWeight.MEDIUM,
  loading = false,
  className,
  titleClassName,
  contentClassName,
}) => {
  const _titleClassName = classNames(
    titleClassName,
    {
      [styles.titleDefault]: (titleFontSize === TitleFontSize.DEFAULT),
      [styles.titleLarge]: (titleFontSize === TitleFontSize.LARGE),
      [styles.titleBold]: (titleFontWeight === TitleFontWeight.BOLD),
    },
  );

  const _contentClassName = classNames(
    contentClassName,
    styles.content,
    {
      [styles.contentNoPadding]: (loading === true),
    },
  );

  return (
    <div className={classNames(styles.container, className)}>
      {title && (
        <h4 className={_titleClassName}>{title}</h4>
      )}
      {children && (
        <div className={_contentClassName}>{children}</div>
      )}
    </div>
  );
};
